import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Suggest_Interface, Suggest_Interface } from 'src/app/Interface/Suggest_Interface';
import { Empty_Suggest_Order_Interface, Suggest_Order_Interface } from 'src/app/Interface/Suggest_Order_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { SuggestService } from 'src/app/Service/Suggest/Suggest.service';
import { SuggestTitleService } from 'src/app/Service/Suggest/SuggestTitle.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-SuggestForm',
  templateUrl: './SuggestForm.component.html',
  styleUrls: ['./SuggestForm.component.scss']
})
export class SuggestFormComponent implements OnInit {

  @Input() inner_Suggest:Suggest_Interface=Empty_Suggest_Interface()

  title_id:string="0"
  Token:String=""
  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>Type your text here...</p>'
  };

  public config = {
    language: 'fa'
  };

  constructor(
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService,
    private Suggest_Service:SuggestService,
    private SuggestTitle_Service:SuggestTitleService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    if (this.inner_Suggest.id > 0)
    {
      this.title_id = this.inner_Suggest.title_id +""
      this.model.editorData = this.inner_Suggest.dsc + ""
      this.UploadImageSrc_List=this.inner_Suggest.file
    }


    this.Read_Title()
  }

  //#region Title

  Title_DataList:Array<General_Interface>
  Read_Title(){
    this.InProccessing=true
    this.SuggestTitle_Service.GetActiveList(this.Token).subscribe(
      data=>{
        this.InProccessing=false
        this.Title_DataList = data
        this.Read_Order_Operation()
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion

  //#region Image
  BaseUrl=environment.BaseUrl
  UploadImageSrc_List:Array<string>=[]
  UploadImageSrc:string=''
  InProccessing_Image1:boolean=false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1=true

    this.Suggest_Service.uploadFile(formData,this.Token).subscribe(
      data=>{
        this.InProccessing_Image1=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.UploadImageSrc=data['filename']
        }
      }
    )

  }

  Remove_uploadImage1(){
    this.UploadImageSrc=''
  }

  Add_uploadImage1(){
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc=''
    this.Alertify_Service.SuccessMessage("Added to the table.")
  }

  UploadImageSrc_List_Delete(id:number)
  {
    this.UploadImageSrc_List.splice(id,1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  modalRef_Image: any;
  ModalimageUrl:string=''
  openModal(template: TemplateRef<any>,imageUrl:string) {
    this.ModalimageUrl=imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion

  //#region Letter Order
  canEditMainForm:boolean=false
  canAnswerMainForm:boolean=false
  Data_List_Order: Array<Suggest_Order_Interface>
  Read_Order_Operation() {
    this.Data_List_Order = []
    this.Suggest_Service.GetOperation(this.Token,this.inner_Suggest.id).subscribe(
      data => {
        this.Data_List_Order = data['result']
        this.canEditMainForm = data['canEditMainForm']
        this.canAnswerMainForm = data['canAnswerMainForm']
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Selected_Order_Operation: Suggest_Order_Interface = Empty_Suggest_Order_Interface()
  LetterHistoryDsc: string = ''
  LetterHistoryPoint: string = '0'
  modalRef_Order: any;
  Data_list_LetterRole: Array<General_Interface> = []
  OpenOrderDialog(template: TemplateRef<any>, item: Suggest_Order_Interface) {
    this.modalRef_Order = this.modalService.show(template);
    this.Data_list_LetterRole = []
    this.LetterHistoryDsc = ''
    this.LetterHistoryPoint = '0'
    this.Selected_Order_Operation = item

  }

  //#endregion

  InProccessing:boolean=false
  onSubmitForm(){

    if(this.title_id=="0")
    {
      this.Alertify_Service.ErrorMessage("Select the suggestion subject.")
    }
    else{
      this.modalRef_Order.hide()
      this.InProccessing=true
      this.Suggest_Service.SubmitTicket(
        this.model.editorData,
        this.LetterHistoryDsc,
        this.inner_Suggest.id,
        Number(this.title_id),
        this.Selected_Order_Operation.id,
        Number(this.LetterHistoryPoint),
        this.Token,
        this.UploadImageSrc_List
        ).subscribe(
        data=>{

          if(this.inner_Suggest.id==0)
            this.Alertify_Service.SuccessMessage("Suggestion submitted successfully.")
          else
            this.Alertify_Service.SuccessMessage("Information saved successfully.")

          this.inner_Suggest.id=data['id']
          this.UploadImageSrc_List=[]
            this.InProccessing = false
            this.Read_Order_Operation()
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )

    }

  }


}
